<template>
  <el-tabs v-model="activeName" @tab-click="tabSelection"  class="clientTab">
    <el-tab-pane v-for="item in tabNames" :label='item.label' :name="item.name">
    </el-tab-pane>
  </el-tabs>
</template>

<script>
export default {
  name: "Tabs",
  props:{
    // 传入一个对象数组，里面必须有name和label属性
    tabNames:{
      type:Array,
      required:true
    }
  },
  data(){
    return {
      activeName: this.tabNames[0].name
    }
  },
  // 传入一个方法，名称为tabClick
  methods:{
    tabSelection(tab){
      this.$emit('tabClick',tab)
    }
  }
}
</script>

<style lang="scss">
.clientTab {
  .el-tabs__item {
    min-width: 50px!important;
  }
}
</style>